export const firebaseConfig = {
    apiKey: "AIzaSyAVhzNyztIQG_BFNM_BKr_1jwR3w-EOcMI",
    authDomain: "oni-nz.firebaseapp.com",
    databaseURL: "https://oni-nz.firebaseio.com",
    projectId: "oni-nz",
    storageBucket: "oni-nz.appspot.com",
    messagingSenderId: "140170893294",
    appId: "1:140170893294:web:7d101ee26f634456dc20ff",
    measurementId: "G-6BRR91S6PT"
};